// extracted by mini-css-extract-plugin
module.exports = {"page-align":"page_align_page-align__BBPm1","content":"page_align_content__RoeO0"};